import { useState, useEffect } from "react";
import { QREditorContextProps } from "@/contexts/QREditorContext/types";

const hasFeedbackUserContent = (data: Record<string, unknown>): boolean => {
  const title = data.title;
  if (typeof title === "string" && title.trim() !== "") {
    return true;
  }

  const categories = data.categories;
  return Array.isArray(categories) && categories.length > 0;
};

export const useQRInitState = (qrEditorContext: QREditorContextProps<any> | null) => {
  const [isQRInit, setIsQRInit] = useState(
    qrEditorContext?.qrData?.qrCodeReference === undefined ? true : false
  );

  useEffect(() => {
    const data = qrEditorContext?.qrData.data || {};
    const qrType = qrEditorContext?.qrData.type;

    if (qrType === "feedback") {
      if (hasFeedbackUserContent(data)) {
        setIsQRInit(false);
      }
      return;
    }

    // Fields that NEVER should change the initial preview
    const QR_IGNORED_FIELDS = ["qrName", "themeColor", "typeName", "form"]; //"logoUrl"

    // Filter only relevant fields for the content
    const contentFields = Object.keys(data).filter((key) => {
      if (QR_IGNORED_FIELDS.includes(key)) return false;

      // Exclude values that are placeholders
      const value = data[key];
      if (!value || value === "") return false;

      return true;
    });

    if (contentFields.length > 0) {
      setIsQRInit(false);
    }
  }, [qrEditorContext?.qrData.data, qrEditorContext?.qrData.type]);

  return isQRInit;
};
